export default "__VITE_ASSET__CokbRIx1__"